import NetworkingIndex from 'Pages/Networking';

import AdminSupportTickets from 'Pages/Admin/Networking/SupportTickets';

export default [
	 { path: '/networking/:user?', component: NetworkingIndex, guards: ['auth'] },
    //
	// { path: '/admin/networking/support-tickets', component: AdminSupportTickets, guards: ['admin'] },
];
